'use client'

import { motion } from 'framer-motion'
import { FileText } from 'lucide-react'
import type { RefObject } from 'react'

interface StepDetalhesProps {
  detalhes: string
  setDetalhes: (valor: string) => void
  onSubmit: () => void
  onSkip: () => void
  onBack: () => void
  textareaRef: RefObject<HTMLTextAreaElement | null>
}

export function StepDetalhes({ detalhes, setDetalhes, onSubmit, onSkip, onBack, textareaRef }: StepDetalhesProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-4 sm:mb-6">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg shadow-purple-500/30">
          <FileText size={24} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-2">Mais algum detalhe?</h2>
        <p className="text-indigo-950/50 dark:text-white/50 text-sm">Opcional - conte-nos mais sobre seu projeto</p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="space-y-4">
        <textarea ref={textareaRef} value={detalhes} onChange={(e) => setDetalhes(e.target.value)} placeholder="Descreva funcionalidades especificas, inspiracoes, diferenciais..." rows={4} className="w-full px-4 py-3 rounded-xl bg-white/85 dark:bg-white/5 border border-purple-500/20 dark:border-white/10 text-indigo-950 dark:text-white placeholder:text-indigo-950/30 dark:placeholder:text-white/30 outline-none transition-all focus:border-purple-500/50 resize-none" />
        <button onClick={onSubmit} className="w-full py-3.5 rounded-full font-medium text-sm bg-purple-600 hover:bg-purple-500 text-white shadow-lg shadow-purple-600/25 transition-all active:scale-[0.98]">Continuar</button>
        <button onClick={onSkip} className="w-full py-2.5 text-sm text-indigo-950/40 dark:text-white/40 hover:text-indigo-950/60 dark:text-white/60 transition-colors">Pular esta etapa</button>
      </motion.div>
      <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} onClick={onBack} className="mt-4 w-full text-center text-sm text-indigo-950/40 dark:text-white/40 hover:text-indigo-950/60 dark:text-white/60 transition-colors">&larr; Voltar</motion.button>
    </motion.div>
  )
}
